import gql from 'graphql-tag';

export default gql`
  mutation updateOffer($id: Int!, $input: OfferInput) {
    updateOffer(id: $id, input: $input) {
      id
      shop_id
      image
      details {
        id
        title
        description
        cta_label
        cta_url
        offer_date
        language_code
        order
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/offer/update.js